// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"174":"9ae690cd26f47e05","5910":"3c7c657436eca73a"}[chunkId] + ".js";
};